import { EnrichClientTransactionsRequest } from 'vopay';
import { useState } from 'react';
import { useApi } from '#shared/providers/Api';

export default function useEnrichPaymentMethodData() {
  const api = useApi();
  const [fetching, setFetching] = useState(false);
  const [requestID, setRequestID] = useState('');

  async function enrichPaymentMethodData(params: EnrichClientTransactionsRequest) {
    try {
      setFetching(true);
      const res = await api.enrichClientTransactions(params);
      if (!res.Success) throw new Error(res.ErrorMessage);
      setRequestID(res.RequestID);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  return { fetching, requestID, enrichPaymentMethodData };
}
